<template>
  <div>
    <b-modal
      hide-backdrop
      body-bg-variant='warning'
      header-bg-variant='warning'
      footer-bg-variant='warning'
      ref="reload-promt-modal"
      id="reload-promt-modal"
      title="New TEAMS Version"
      @ok="reloadPage">
      <p class="my-4">A new version of TEAMS is available. To start using it, please reload this page.</p>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ReloadPromt',

  methods: {
    reloadPage () {
      location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReloadPromt.vue